import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const deleteJobReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.DELETE_JOB_START:
            return { ...state, loading: true, error: null };

        case types.DELETE_JOB_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.DELETE_JOB_ERROR:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};

export default deleteJobReducer;
